export default "__VITE_ASSET__FgR2dneQ__"